<template>
  <div class="object-map" id="geowerft-map-wrapper">
    <!-- Tutorial Box -->
    <div
      v-if="
        ('empty' === geowerft_get_cookie_by_name('geowerft_tutorial') &&
          true === geoWerftData.checkboxes.enable_tutorial) ||
        ('empty' === geowerft_get_cookie_by_name('prop_offline_tutorial') &&
          true === geoWerftData.checkboxes.prop_offline_single_overlay &&
          true === geoWerftData.user.logged_in)
      "
      class="mw-geowerft-tut-arrow-wrapper"
    >
      <div
        v-if="
          true === geoWerftData.checkboxes.prop_offline_single_overlay &&
          false === geoWerftData.checkboxes.prop_offline_include_overlay &&
          true === geoWerftData.user.logged_in &&
          'empty' === geowerft_get_cookie_by_name('prop_offline_tutorial')
        "
      ></div>
      <div v-else-if="true === geoWerftData.checkboxes.enable_tutorial">
        <div class="mw-geo-arrow-one-wrapper">
          <div
            class="mw-geo-arrow-one"
            v-if="geoWerftData.customimages.tutorial_picture_one"
          >
            <img
              class="tutorial-picture-one"
              alt=""
              v-bind:src="geoWerftData.customimages.tutorial_picture_one"
            />
          </div>
          <div v-else class="mw-geo-arrow-one">
            <em
              class="fa fa-arrow-up fa-4x tutorial-arrow blinking-arrow"
              aria-hidden="true"
            ></em>
          </div>
        </div>
        <div class="mw-geo-arrow-two-wrapper">
          <div
            class="mw-geo-arrow-two"
            v-if="geoWerftData.customimages.tutorial_picture_two"
          >
            <img
              class="tutorial-picture-two"
              alt=""
              v-bind:src="geoWerftData.customimages.tutorial_picture_two"
            />
          </div>
          <div v-else class="mw-geo-arrow-two">
            <em
              class="fa fa-arrow-up fa-4x tutorial-arrow-two blinking-arrow"
              aria-hidden="true"
            ></em>
          </div>
        </div>
        <div class="mw-geo-arrow-three-wrapper">
          <div
            class="mw-geo-arrow-three"
            v-if="geoWerftData.customimages.tutorial_picture_three"
          >
            <img
              class="tutorial-picture-three"
              alt=""
              v-bind:src="geoWerftData.customimages.tutorial_picture_three"
            />
          </div>
          <div v-else class="mw-geo-arrow-three">
            <em
              class="fa fa-arrows fa-4x tutorial-move-arrow blinking-arrow"
              aria-hidden="true"
            ></em>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="
        ('empty' === geowerft_get_cookie_by_name('geowerft_tutorial') &&
          true === geoWerftData.checkboxes.enable_tutorial) ||
        ('empty' === geowerft_get_cookie_by_name('prop_offline_tutorial') &&
          true === geoWerftData.checkboxes.prop_offline_single_overlay &&
          true === geoWerftData.user.logged_in)
      "
      class="geowerft-tutorial-wrapper"
    >
      <div
        @click="
          mw_set_geowerft_cookie('prop_offline_tutorial', '1', { days: 30 })
        "
        v-if="
          'empty' === geowerft_get_cookie_by_name('prop_offline_tutorial') &&
          true === geoWerftData.checkboxes.prop_offline_single_overlay &&
          false === geoWerftData.checkboxes.prop_offline_include_overlay &&
          true === geoWerftData.user.logged_in
        "
      >
        <div
          v-html="
            geoWerftData.texts.prop_offline_tutorial_text.replace(
              '##LINK##',
              geoWerftData.texts.prop_offline_picture
            )
          "
          class="geowerft-prop-offline-explain-text"
        ></div>
        <div
          class="prop-offline-finish-btn-single"
          onclick="jQuery( this ).parent().parent().hide();"
        >
          Fertig
        </div>
      </div>
      <div v-else-if="true === geoWerftData.checkboxes.enable_tutorial">
        <div class="geowerft-tutorialbox-one-wrapper">
          <div
            class="geowerft-tutorial-explain-text"
            v-html="geoWerftData.texts.tutorial_text_one"
          ></div>
          <div class="geowerft-tutorial-button-wrapper">
            <div class="geowerft-tutorial-btn-left">
              <button
                data-geo-tutorial="skip"
                @click="render_next_tutorial_step($event)"
              >
                Intro überspringen
              </button>
            </div>
            <div class="geowerft-tutorial-btn-right">
              <button
                data-geo-tutorial="box-2"
                data-geo-box="geowerft-tutorialbox-one-wrapper"
                data-geo-box-next="geowerft-tutorialbox-two-wrapper"
                @click="render_next_tutorial_step($event)"
              >
                weiter
              </button>
            </div>
          </div>
        </div>
        <div class="geowerft-tutorialbox-two-wrapper">
          <div
            class="geowerft-tutorial-explain-text"
            v-html="geoWerftData.texts.tutorial_text_two"
          ></div>
          <div class="geowerft-tutorial-btn-left">
            <button
              data-geo-tutorial="skip"
              @click="render_next_tutorial_step($event)"
            >
              Intro überspringen
            </button>
          </div>
          <div class="geowerft-tutorial-btn-right">
            <button
              data-geo-tutorial="box-3"
              data-geo-box="geowerft-tutorialbox-two-wrapper"
              data-geo-box-next="geowerft-tutorialbox-three-wrapper"
              @click="render_next_tutorial_step($event)"
            >
              weiter
            </button>
          </div>
        </div>
        <div class="geowerft-tutorialbox-three-wrapper">
          <div
            class="geowerft-tutorial-explain-text"
            v-html="geoWerftData.texts.tutorial_text_three"
          ></div>
          <div
            v-if="true === geoWerftData.checkboxes.prop_offline_include_overlay"
            class="geowerft-tutorial-btn-left"
          >
            <button
              data-geo-tutorial="skip"
              @click="render_next_tutorial_step($event)"
            >
              Intro überspringen
            </button>
          </div>
          <div
            v-bind:class="
              true === geoWerftData.checkboxes.prop_offline_include_overlay &&
              true === geoWerftData.user.logged_in
                ? 'geowerft-tutorial-btn-right'
                : 'geowerft-tutorial-btn-finish'
            "
          >
            <button
              v-html="
                true === geoWerftData.checkboxes.prop_offline_include_overlay &&
                true === geoWerftData.user.logged_in
                  ? 'weiter'
                  : 'Fertig'
              "
              data-geo-tutorial="skip"
              @click="render_next_tutorial_step($event, 'three')"
            >
              Fertig
            </button>
          </div>
        </div>
        <div
          id="prop-offline-explain"
          style="display: none"
          v-if="
            true === geoWerftData.checkboxes.prop_offline_include_overlay &&
            true === geoWerftData.user.logged_in
          "
          class="geowerft-tutorialbox-four-wrapper"
        >
          <div
            class="geowerft-tutorial-explain-text"
            v-html="
              geoWerftData.texts.prop_offline_tutorial_text.replace(
                '##LINK##',
                geoWerftData.texts.prop_offline_picture
              )
            "
          ></div>
          <div class="prop-offline-finish-btn">
            <button
              data-geo-tutorial="skip"
              @click="render_next_tutorial_step($event)"
            >
              Fertig
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- TutorialBox Ende -->
    <div
      v-if="geoWerftData.checkboxes.enable_filialen_mode"
      class="geowerft-lasche"
    >
      <i class="fa fa-chevron-right" aria-hidden="true"></i>
    </div>
    <div
      v-if="true === this.geoWerftData.checkboxes.display_google_search"
      class="autocomplete-location-picker"
    >
      <gmap-autocomplete
        v-bind:placeholder="this.geoWerftData.texts.autocomplete_placeholder"
        :options="{
          componentRestrictions: { country: ['de'] },
          fields: ['geometry'],
        }"
        v-on:place_changed="setPlace"
      >
      </gmap-autocomplete>
    </div>

    <div
      v-if="'' !== geoWerftData.enable_ai_quick_chat_custom"
      class="geomap-wrapped-custom-ai"
      v-html="geoWerftData.enable_ai_quick_chat_custom"
    ></div>

    <div
      v-if="true === geoWerftData.enable_ai_quick_chat"
      class="mw-quick-ai-map-wrapper"
    >
      <div class="mw-quick-ai-icon-or-pic"></div>
      <div class="mw-quick-ai-input-wrapper">
        <label for="mw-quick-ai-map-search-input">{{
          geoWerftData.ai_quick_label
        }}</label>
        <input
          v-bind:placeholder="geoWerftData.ai_quick_placeholder"
          type="text"
          value=""
          name="mw_quick_ai_map_search"
          id="mw-quick-ai-map-search-input"
        />
        <button
          type="button"
          class="mw-quick-ai-record-btn-wrapper"
          title="Aufnahme starten"
        >
          <span v-html="geoWerftData.ai_quick_svg"></span>
        </button>
      </div>
      <dialog
        class="mw-custom-gif-loader-ai-assistant mw-block-modal mw-backdrop-close chrome"
      >
        <div class="mw-assistant-loader-center">
          <div class="ai-search-wrapper">
            <div
              v-if="geoWerftData.ai_load_img_pre"
              class="ai-search-mascot-asset1"
            >
              <div class="ai-search-mascot-cloud1">
                <img
                  v-bind:src="geoWerftData.ai_load_img_pre"
                  alt="Cloud Asset"
                />
              </div>
            </div>
            <div class="ai-search-mascot-wrapper">
              <div class="ai-search-mascot">
                <img
                  v-bind:src="geoWerftData.ai_load_img"
                  width="200px"
                  alt="KI Suche läuft"
                />
              </div>
            </div>
            <div
              v-if="geoWerftData.ai_load_img_after"
              class="ai-search-mascot-asset2"
            >
              <div class="ai-search-mascot-cloud2">
                <img
                  v-bind:src="geoWerftData.ai_load_img_after"
                  alt="Cloud Asset"
                />
              </div>
            </div>
            <div class="ai-search-mascot-infotext">
              <p v-html="geoWerftData.ai_load_text"></p>
            </div>
          </div>
        </div>
      </dialog>
    </div>

    <div
      class="reset-map-bounds-wrapper"
      v-if="true === geoWerftData.reset_bounds"
    >
      <button
        v-on:click="mw_restore_init_bounds()"
        class="mw-reset-map-bounds-btn"
        v-html="geoWerftData.reset_bounds_label"
      ></button>
    </div>

    <div
      v-if="geoWerftData.checkboxes.enable_filialen_mode"
      class="mw-geo-makler-search-holder"
    ></div>

    <div
      v-if="
        loadingStatus === 0 &&
        found_props > 0 &&
        this.geoWerftData.checkboxes.next_pin_active
      "
      class="mw-geo-to-next-marker-wrapper"
    >
      <div
        v-if="
          false === this.geoWerftData.checkboxes.enable_filialen_mode &&
          filteredObjects > 0
        "
        class="mw-geo-to-next-marker-text-prop"
        v-html="this.geoWerftData.texts.text_next_pin_prop"
      ></div>
      <div
        v-if="
          false === this.geoWerftData.checkboxes.enable_filialen_mode &&
          filteredObjects === 0
        "
        class="mw-geo-to-next-marker-text-prop no-immo-found-filter"
        v-html="this.geoWerftData.texts.text_filter_next_pin_prop"
      ></div>
      <div
        v-if="true === this.geoWerftData.checkboxes.enable_filialen_mode"
        class="mw-geo-to-next-marker-text-ppl"
        v-html="this.geoWerftData.texts.text_next_pin_ppl"
      ></div>
      <div
        v-if="
          false === this.geoWerftData.checkboxes.enable_filialen_mode &&
          filteredObjects > 0
        "
        v-on:click="get_the_closest_marker()"
        class="mw-geo-to-next-marker-button-prop mw-go-to-next-button"
        v-html="this.geoWerftData.texts.text_button_next_pin_prop"
      ></div>
      <div
        v-if="true === this.geoWerftData.checkboxes.enable_filialen_mode"
        v-on:click="get_the_closest_marker()"
        class="mw-geo-to-next-marker-button-ppl mw-go-to-next-button"
        v-html="this.geoWerftData.texts.text_button_next_pin_ppl"
      ></div>
    </div>

    <gmap-map
      ref="main_gmap_obj"
      :center="this.geoWerftData.map.center"
      :zoom="this.geoWerftData.map.zoom"
      v-on:dragend="update_current_map_center($event)"
      v-on:bounds_changed.passive="searchLocation($event)"
      v-on:zoom_changed.passive="get_current_zoom($event)"
      style="width: 100%; height: 100%"
      :options="{
        styles: this.geoWerftData.custom_map_style,
        minZoom: 3,
        maxZoom: this.geoWerftData.map.maxZoom,
        zoomControl: this.geoWerftData.map.map_zoom_control,
        mapTypeControl: this.geoWerftData.checkboxes.show_map_satellite_switch,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        mapTypeId: this.geoWerftData.map.map_type_id,
        scrollwheel: true,
        gestureHandling: this.geoWerftData.map.map_touch_mode,
      }"
    >
      <template v-if="this.geoWerftData.checkboxes.enable_filialen_mode">
        <gmap-info-window
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen = false"
        >
          <div
            v-bind:id="'pin-id-' + win_filialen_id"
            class="mw-geo-filialien-infowin-wrapper"
          >
            <div class="infowindow-real-estate-agent-left">
              <div v-if="win_img_src" class="infowindow-real-estate-img">
                <img v-bind:src="win_img_src" />
              </div>
              <div
                class="infowindow-real-estate-agent-headline"
                v-html="win_headline"
              ></div>
              <div
                class="infowindow-real-estate-agent-street"
                v-html="win_strasse"
              ></div>
              <div
                class="infowindow-real-estate-agent-plz"
                v-html="win_plz"
              ></div>
            </div>
            <div class="infowindow-real-estate-agent-right">
              <div v-if="win_name" class="infowindow-real-estate-agent-title">
                {{ win_name }}
              </div>
              <div v-if="win_tel" class="infowindow-real-estate-agent-phone">
                <i class="fa fa-phone" aria-hidden="true"></i> {{ win_tel }}
              </div>
              <div
                v-if="win_tel_zwei"
                class="infowindow-real-estate-agent-phone"
              >
                <i class="fa fa-phone" aria-hidden="true"></i>
                {{ win_tel_zwei }}
              </div>
              <div v-if="win_fax" class="infowindow-real-estate-agent-fax">
                <i class="fa fa-print" aria-hidden="true"></i> {{ win_fax }}
              </div>
            </div>
            <div class="infowindow-real-estate-agent-bottom">
              <div v-if="win_tel" class="single-real-estate-agent-url">
                <a
                  :href="win_link_extern_url"
                  v-html="this.geoWerftData.filialen_landingpage_label"
                  target="_blank"
                ></a>
              </div>
            </div>
          </div>
        </gmap-info-window>

        <gmap-cluster
          :styles="clusterStyles"
          :maxZoom="this.geoWerftData.cluster_break_zoom"
          :zoomOnClick="true"
        >
          <gmap-marker
            :key="index"
            v-for="(marker, index) in this.geoWerftData.map.markers"
            :position="marker.position"
            :clickable="true"
            :icon="marker.url"
            :title="marker.title"
            :label="marker.label"
            :animation="marker.animation"
            @click="toggle_filialen_window(marker, index)"
          >
          </gmap-marker>
        </gmap-cluster>
      </template>
      <template v-else>
        <div v-if="this.markerInfo">
          <gmap-info-window
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="infoWinOpen = false"
          >
            <InfoWindow
              :infoContent="infoContent"
              :image_url="image_url"
              :infoWindowPos="infoWindowPos"
              :win_objekttitel="win_objekttitel"
              :win_plz="win_plz"
              :win_ort="win_ort"
              :win_id="win_id"
              :win_gesamtflaeche="win_gesamtflaeche"
              :win_tour="win_tour"
              :win_geolocation="win_geolocation"
              :win_objektart_raw="win_objektart_raw"
              :win_kennung="win_kennung"
              :win_res_begin="win_res_begin"
              :win_res_ende="win_res_ende"
              :win_price="win_price"
              :win_price_rent="win_price_rent"
              :win_display_badge_new="win_display_badge_new"
              :win_erwerbsart="win_erwerbsart"
              :win_homepage_status="win_homepage_status"
              :geoWerftData="this.geoWerftData"
              :win_count_adults="win_count_adults"
              :win_count_childs="win_count_childs"
              :win_barrierefrei="win_barrierefrei"
              :win_haustiere="win_haustiere"
              :win_price_qm="win_price_qm"
              :win_teilbarkeit="win_teilbarkeit"
              :win_bueroflaeche="win_bueroflaeche"
              :win_bezug="win_bezug"
              :win_zimmer="win_zimmer"
              :win_wohnflaeche="win_wohnflaeche"
              :win_vermietbare_flaeche="win_vermietbare_flaeche"
              :win_grundstuecksflaeche="win_grundstuecksflaeche"
              :win_link_extern="win_link_extern"
              :win_link_extern_url="win_link_extern_url"
              :permalink="permalink"
            ></InfoWindow>
          </gmap-info-window>
        </div>

        <div v-else-if="!this.markerInfo">
          <gmap-info-window
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="infoWinOpen = false"
          >
            <InfoWindowPaginator
              :estates="this.estates"
              :geoWerftData="this.geoWerftData"
            ></InfoWindowPaginator>
          </gmap-info-window>
        </div>

        <span
          v-if="
            this.geoWerftData.show_cluster &&
            this.geoWerftData.show_cluster_no_pictures
          "
        >
          <gmap-cluster
            :key="index"
            :maxClusterZoom="this.geoWerftData.cluster_break_zoom"
            :zoomOnClick="true"
            @click="toggleClusterMarker($event)"
          >
            <gmap-marker
              :key="index"
              v-for="(marker, index) in this.geoWerftData.map.markers"
              :position="marker.position"
              :clickable="true"
              :icon="marker.url"
              :title="marker.title"
              :label="marker.label"
              :animation="marker.animation"
              @click="toggleInfoWindow(marker, index)"
            >
            </gmap-marker>
          </gmap-cluster>
        </span>
        <span
          v-else-if="
            this.geoWerftData.show_cluster &&
            !this.geoWerftData.show_cluster_no_pictures
          "
        >
          <gmap-cluster
            :styles="clusterStyles"
            :maxClusterZoom="this.geoWerftData.cluster_break_zoom"
            :zoomOnClick="true"
            @click="toggleClusterMarker($event)"
          >
            <gmap-marker
              :key="index"
              v-for="(marker, index) in this.geoWerftData.map.markers"
              :position="marker.position"
              :clickable="true"
              :icon="marker.url"
              :title="marker.title"
              :label="marker.label"
              :animation="marker.animation"
              @click="toggleInfoWindow(marker, index)"
            >
            </gmap-marker>
          </gmap-cluster>
          <gmap-marker
            :key="index"
            v-for="(marker, index) in this.geoWerftData.map.no_cluster_markers"
            :position="marker.position"
            :clickable="true"
            :icon="marker.url"
            :title="marker.title"
            :label="marker.label"
            :animation="marker.animation"
            @click="toggleInfoWindow(marker, index)"
          >
          </gmap-marker>
        </span>
        <span v-else-if="false === this.geoWerftData.show_cluster">
          <gmap-marker
            :key="index"
            v-for="(marker, index) in this.geoWerftData.map.markers"
            :position="marker.position"
            :clickable="true"
            :icon="marker.url"
            :title="marker.title"
            :label="marker.label"
            :animation="marker.animation"
            @click="toggleInfoWindow(marker, index)"
          >
          </gmap-marker>
        </span>
      </template>
    </gmap-map>
  </div>
</template>

<script>
import EventBus from "../data/eventbus.js";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import InfoWindow from "./InfoWindow";
import InfoWindowPaginator from "./InfoWindowPaginator";
export default {
  components: {
    GmapCluster,
    InfoWindow,
    InfoWindowPaginator,
  },
  mounted() {
    let that = this;
    EventBus.$on("geowerft_list_click", function (current_id) {
      that.geoWerftData.map.zoom = that.geoWerftData.map.maxZoom;
      that.toggle_single_info_window_on_emit(current_id);
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        var elmnt = document.getElementById("geowerft-map-wrapper");
        elmnt.scrollIntoView();
      }
    });
  },
  props: ["geoWerftData"],
  data() {
    return {
      estates: [],
      gridSize: 50,
      clusterStyles: [
        {
          textColor: "white",
          url: this.geoWerftData.cluster_pin_far,
          height: 32.2,
          width: 33,
          fontWeight: this.geoWerftData.cluster_font_weight,
        },
        {
          textColor: "white",
          url: this.geoWerftData.cluster_pin_far,
          height: 32.2,
          width: 33,
          fontWeight: this.geoWerftData.cluster_font_weight,
        },
        {
          textColor: "white",
          url: this.geoWerftData.cluster_pin_far,
          height: 32.2,
          width: 33,
          fontWeight: this.geoWerftData.cluster_font_weight,
        },
      ],
      infoContent: "",
      image_url: "",
      permalink: "",
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      //optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      win_id: "",
      win_price: "",
      win_price_rent: "",
      win_price_qm: "",
      win_objekttitel: "",
      win_plz: "",
      win_ort: "",
      win_geolocation: "",
      win_objektart_raw: "",
      win_kennung: "",
      win_count_adults: "",
      win_count_childs: "",
      win_barrierefrei: "",
      win_haustiere: "",
      win_zimmer: "",
      win_teilbarkeit: "",
      win_bueroflaeche: "",
      win_bezug: "",
      win_wohnflaeche: "",
      win_vermietbare_flaeche: "",
      win_grundstuecksflaeche: "",
      win_homepage_status: "",
      win_link_extern: "",
      win_link_extern_url: "",
      win_headline: "",
      win_headline_ort: "",
      win_strasse: "",
      win_tel: "",
      win_tel_zwei: "",
      win_mail: "",
      win_fax: "",
      win_vermarktungsart: "",
      win_erwerbsart: "",
      win_res_begin: "",
      win_res_ende: "",
      win_display_badge_new: "",
      win_filialen_id: "",
      win_img_src: "",
      win_name: "",
      win_gesamtflaeche: "",
      win_tour: "",
      coords_array: [],
      current_center: 0,
      props_loaded_once: false,
      init_optimal_bounds: [],
    };
  },
  computed: {
    filteredObjects() {
      return this.geoWerftData.objects.filtered.length;
    },
    loadingStatus() {
      // Return the length of the objects array
      return this.geoWerftData.objects.visible.length;
    },
    inView() {
      // Return the length of the objects array
      return this.geoWerftData.objects.visible;
    },
    found_props() {
      return this.geoWerftData.objects.all.length;
    },
  },
  watch: {
    filteredObjects: function (len) {
      this.build_coords_array();
    },
    loadingStatus: function (arrayLength) {
      if (
        true === this.geoWerftData.enable_comfort_zoom &&
        arrayLength > 0 &&
        this.props_loaded_once === false &&
        !new URLSearchParams(window.location.search).get("google_search")
      ) {
        this.props_loaded_once = true;
        this.$refs.main_gmap_obj.$mapPromise.then((main_map_obj) => {
          this.generateOptimalMapSettings(
            main_map_obj,
            this.geoWerftData.objects.filtered
          );
        });
      }
      this.addMarkers();
    },
  },
  methods: {
    generateOptimalMapSettings(map_obj, filtered_props) {
      // Calculate the bounds of the locations.
      const tmp_bounds = new google.maps.LatLngBounds();
      filtered_props.forEach(function (single_prop) {
        // Extend the bounds to include this location.
        if (single_prop.geo_latitude && single_prop.geo_longitude) {
          tmp_bounds.extend(
            new google.maps.LatLng(
              single_prop.geo_latitude,
              single_prop.geo_longitude
            )
          );
        }
      });
      this.geoWerftData.map.center = tmp_bounds.getCenter();
      map_obj.fitBounds(tmp_bounds);
      // Hier die Bounds zwischenspeichern, um diese später nutzen zu können.
      this.init_optimal_bounds = tmp_bounds;
    },
    mw_restore_init_bounds() {
      this.geoWerftData.map.center = this.init_optimal_bounds.getCenter();
      this.$refs.main_gmap_obj.fitBounds(this.init_optimal_bounds);
    },
    mw_change_watchlist_status_on_load(current_id) {
      if (
        current_id &&
        document.querySelector("#watch-class-" + current_id) &&
        document
          .querySelector("#watch-class-" + current_id)
          .classList.contains("mw-watchlist-delete")
      ) {
        setTimeout(function () {
          document
            .querySelector("#mw-gtb-like-in-window-" + current_id)
            .classList.add("mw-gtb-watchlist-liked");
        }, 800);
      }
    },
    mw_format_area(number) {
      if (undefined === number || "" === number) {
        return "";
      }
      var result = number;
      // replace special chars.
      result = this.replace_special_chars(result);
      // format the price.
      return new Intl.NumberFormat("de-DE", {
        style: "decimal",
      }).format(result);
    },
    replace_special_chars(str_number) {
      if (str_number.substring(str_number.length - 3) === ".00") {
        str_number = str_number.substring(0, str_number.length - 3);
      }

      str_number = str_number.replace(/€/g, "");
      str_number = str_number.replace(/CHF/g, "");
      str_number = str_number.replace(/m²/g, "");

      // Variante aus der Immowerft in JS implementiert
      var num_position_comma = str_number.indexOf(",");
      var num_position_dot = str_number.indexOf(".");
      var check_number = str_number.replace(",", "|");
      if (num_position_comma > num_position_dot) {
        check_number = check_number.replace(".", "");
      }
      str_number = check_number.replace("|", ".");

      str_number = str_number.trim();
      return str_number;
    },
    geowerft_get_cookie_by_name(cookie_name) {
      let name = cookie_name + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let cookie_list = decodedCookie.split(";");
      let len = cookie_list.length;
      for (let i = 0; i < len; i++) {
        let current_cookie = cookie_list[i];
        while (current_cookie.charAt(0) === " ") {
          current_cookie = current_cookie.substring(1);
        }
        if (current_cookie.indexOf(name) === 0) {
          return current_cookie.substring(name.length, current_cookie.length);
        }
      }
      return "empty";
    },
    mw_set_geowerft_cookie(name, value = "1", options = {}) {
      const {
        // Entweder maxAge (Sekunden) ODER days/hours/minutes angeben
        maxAgeSeconds,
        days,
        hours,
        minutes,
        path = "/",
        domain,
        secure = typeof location !== "undefined"
          ? location.protocol === "https:"
          : false,
        sameSite = "Lax", // "Lax" | "Strict" | "None" (bei "None" MUSS secure=true sein)
      } = options;

      // Wert sicher kodieren
      const encodedValue = encodeURIComponent(String(value));

      // Dauer berechnen
      let parts = [`${name}=${encodedValue}`];

      if (typeof maxAgeSeconds === "number") {
        parts.push(`Max-Age=${Math.max(0, Math.floor(maxAgeSeconds))}`);
      } else if (days || hours || minutes) {
        const totalMs =
          (days ? days * 24 * 60 * 60 * 1000 : 0) +
          (hours ? hours * 60 * 60 * 1000 : 0) +
          (minutes ? minutes * 60 * 1000 : 0);
        const expires = new Date(Date.now() + totalMs).toUTCString();
        parts.push(`Expires=${expires}`);
      } else {
        // Fallback: 1 Jahr
        const expires = new Date(
          Date.now() + 365 * 24 * 60 * 60 * 1000
        ).toUTCString();
        parts.push(`Expires=${expires}`);
      }

      // Path/Domain
      if (path) parts.push(`Path=${path}`);
      if (domain) parts.push(`Domain=${domain}`);

      // SameSite/ Secure
      if (sameSite) parts.push(`SameSite=${sameSite}`);
      if (secure || sameSite === "None") parts.push("Secure");

      document.cookie = parts.join("; ");
    },
    render_next_tutorial_step(event, step = "") {
      let current_action = event.target.getAttribute("data-geo-tutorial");
      let current_box = event.target.getAttribute("data-geo-box");
      let next_box = event.target.getAttribute("data-geo-box-next");
      let wrapper = document.querySelector(".geowerft-tutorial-wrapper");

      let arrow_one = document.querySelector(".mw-geo-arrow-one-wrapper");
      let arrow_two = document.querySelector(".mw-geo-arrow-two-wrapper");
      let arrow_three = document.querySelector(".mw-geo-arrow-three-wrapper");
      let arrow_wrapper = document.querySelector(
        ".mw-geowerft-tut-arrow-wrapper"
      );

      switch (current_action) {
        case "skip":
          // Falls die Marktbeobachtungserklärung aktiv ist, wird dieser schritt abgeändert.
          if (
            "three" === step &&
            true ===
              this.geoWerftData.checkboxes.prop_offline_include_overlay &&
            true === this.geoWerftData.user.logged_in
          ) {
            arrow_wrapper.style.display = "none";
            arrow_three.style.display = "none";
            document.querySelector(
              ".geowerft-tutorialbox-three-wrapper"
            ).style.display = "none";
            document.querySelector("#prop-offline-explain").style.display =
              "block";
          } else {
            // Der Benutzer möchte das Tutorial überspringen. Cookie setzen und schließen.
            wrapper.style.display = "none";
            arrow_wrapper.style.display = "none";
            arrow_three.style.display = "none";
            arrow_two.style.display = "none";
            arrow_one.style.display = "none";
            this.mw_set_geowerft_cookie("geowerft_tutorial", "1", { days: 30 });
          }
          break;
        case "box-2":
          arrow_one.style.display = "none";
          arrow_two.style.display = "block";
          document.querySelector("." + current_box).style.display = "none";
          document.querySelector("." + next_box).style.display = "block";
          break;
        case "box-3":
          arrow_two.style.display = "none";
          arrow_three.style.display = "block";
          document.querySelector("." + current_box).style.display = "none";
          document.querySelector("." + next_box).style.display = "block";
          break;
      }
    },
    update_current_map_center(event) {
      this.geoWerftData.map.center = this.current_center;
    },
    get_current_zoom(zoom) {
      this.geoWerftData.map.zoom = zoom;
    },
    setPlace(place) {
      if (!place) return;
      this.geoWerftData.map.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.geoWerftData.map.zoom = parseInt(
        this.geoWerftData.map_settings.google_search_zoom_level
      );
    },
    searchLocation(event) {
      // Don't run if value is missing
      if (undefined == event) {
        return;
      }
      // Get the values from the event
      let northEast = event.getNorthEast();
      let southWest = event.getSouthWest();
      // Update the dat bus
      this.geoWerftData.map.bound = {
        northEast: {
          lat: parseFloat(northEast.lat()),
          lng: parseFloat(northEast.lng()),
        },
        southWest: {
          lat: parseFloat(southWest.lat()),
          lng: parseFloat(southWest.lng()),
        },
      };
      this.current_center = event.getCenter();
    },
    get_customizer_image_for_marker(currentMarkerStatus, display_badge_new) {
      let link = "";

      if (currentMarkerStatus) {
        currentMarkerStatus = currentMarkerStatus.toLowerCase();
      }

      if (display_badge_new) {
        return this.geoWerftData.marker_image.google_maps_marker_badge_new;
      }

      switch (currentMarkerStatus) {
        case "online":
          if (
            this.geoWerftData.marker_image.google_maps_marker_online !== false
          ) {
            link = this.geoWerftData.marker_image.google_maps_marker_online;
          }
          break;
        case "in vorbereitung":
          if (
            this.geoWerftData.marker_image
              .google_maps_marker_in_vorbereitung !== false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_in_vorbereitung;
          }
          break;
        case "verkauft":
          if (
            this.geoWerftData.marker_image.google_maps_marker_verkauft !== false
          ) {
            link = this.geoWerftData.marker_image.google_maps_marker_verkauft;
          }
          break;
        case "referenz":
          if (
            this.geoWerftData.marker_image.google_maps_marker_referenz !== false
          ) {
            link = this.geoWerftData.marker_image.google_maps_marker_referenz;
          }
          break;
        case "secret sale":
          if (
            this.geoWerftData.marker_image.google_maps_marker_secret_sale !==
            false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_secret_sale;
          }
          break;
        case "aktive marktbeobachtung":
          if (
            this.geoWerftData.marker_image
              .google_maps_marker_marktbeobachtung !== false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_marktbeobachtung;
          }
          break;
        case "marktbeobachtung":
          if (
            this.geoWerftData.marker_image
              .google_maps_marker_marktbeobachtung !== false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_marktbeobachtung;
          }
          break;
        case "neubau":
        case "neubau stammobjekt":
        case "neubau stammobjekt referenz":
          if (
            this.geoWerftData.marker_image.google_maps_marker_neubauobjekt !==
            false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_neubauobjekt;
          }
          break;
        case "neubau objekt":
          if (
            this.geoWerftData.marker_image.google_maps_marker_neubauobjekt !==
            false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_neubauobjekt;
          }
          break;
        case "neubau referenz":
          if (
            this.geoWerftData.marker_image.google_maps_marker_neubaureferenz !==
            false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_neubaureferenz;
          }
          break;
        case "exklusiv referenz":
          if (
            this.geoWerftData.marker_image
              .google_maps_marker_exlusive_object !== false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_exlusive_object;
          }
          break;
        case "bieterverfahren":
          if (
            this.geoWerftData.marker_image.google_maps_marker_auction !== false
          ) {
            link = this.geoWerftData.marker_image.google_maps_marker_auction;
          }
          break;
        case "mietbörse":
        case "mietboerse":
          if (
            this.geoWerftData.marker_image.google_maps_marker_mietboerse !==
            false
          ) {
            link = this.geoWerftData.marker_image.google_maps_marker_mietboerse;
          }
          break;
        case "immobiliendepot":
          if (
            this.geoWerftData.marker_image
              .google_maps_marker_immobiliendepot !== false
          ) {
            link = this.geoWerftData.marker_image
              .google_maps_marker_immobiliendepot;
          }
          break;
        default:
          link =
            this.geoWerftData.marker_image.google_maps_marker_default +
            "/images/GooglePin.png";
          break;
      }

      return link;
    },
    build_coords_array() {
      this.coords_array = [];
      for (let i = 0; i < this.geoWerftData.objects.filtered.length; i++) {
        // Hier Prüfen ob nur bestimmte Objekte ausgeschlossen werden sollen.
        if (
          true === this.geoWerftData.checkboxes.exclude_in_closest_prop &&
          (this.geoWerftData.texts.exclude_in_closest_prop_status.includes(
            this.geoWerftData.objects.filtered[i].homepage_status
          ) ||
            this.geoWerftData.texts.exclude_in_closest_prop_status.includes(
              this.geoWerftData.objects.filtered[i].vermarktungsart
            ))
        ) {
          // Wenn das aktuelle Objekt ein treffer ist dann im Loop überspringen.
          continue;
        }
        this.coords_array.push({
          position: {
            lat: parseFloat(this.geoWerftData.objects.filtered[i].geo_latitude),
            lng: parseFloat(
              this.geoWerftData.objects.filtered[i].geo_longitude
            ),
          },
        });
      }
    },
    set_selected_prop_offline(dom_elm, id) {
      if (
        id &&
        true === this.geoWerftData.checkboxes.allow_prop_offline_detection
      ) {
        var that = this;
        if (confirm(this.geoWerftData.texts.prop_offline_explain_text)) {
          jQuery
            .ajax({
              url: rest_url + "geowerft/v1/property/" + id + "/offline",
              method: "PUT",
              data: {
                actionkind: this.geoWerftData.texts.prop_offline_akt_kind,
                actiontype: this.geoWerftData.texts.prop_offline_akt_type,
              },
              beforeSend: function (xhr) {
                xhr.setRequestHeader("X-WP-Nonce", wp_nonce.nonce);
              },
            })
            .done(function (response) {
              alert(that.geoWerftData.texts.prop_offline_success_text);
              setTimeout(function () {
                location.reload(true);
              }, 2000);
            });
        }
      }
    },
    addMarkers() {
      // Empty the markers array
      this.geoWerftData.map.markers = [];
      this.geoWerftData.map.no_cluster_markers = [];

      // Loop the objects and put them on the map
      let title, url;
      let exclude_status = "";
      for (let i = 0; i < this.geoWerftData.objects.visible.length; i++) {
        // Add marker to the array

        title = (this.geoWerftData.objects.visible[i].kennung || "") + "-";

        if (this.geoWerftData.checkboxes.enable_filialen_mode) {
          title = this.geoWerftData.objects.visible[i].ort;
          url = this.geoWerftData.cluster_pin_near;
        } else {
          title += this.geoWerftData.objects.visible[i].objektart_raw || "";
          if (
            this.geoWerftData.objects.visible[i].vermarktungsart !== "" &&
            this.geoWerftData.objects.visible[i].vermarktungsart !==
              "not_set_ver" &&
            this.geoWerftData.objects.visible[i].vermarktungsart !== undefined
          ) {
            title =
              title +
              "-" +
              this.geoWerftData.objects.visible[i].vermarktungsart;
          }
          if (
            this.geoWerftData.objects.visible[
              i
            ].homepage_status.toLowerCase() === "verkauft" &&
            this.geoWerftData.objects.visible[i].erwerbsart.toLowerCase() ===
              "rent"
          ) {
            title = title + "-" + "Vermietet";
          } else if (this.geoWerftData.objects.visible[i].homepage_status) {
            title =
              title +
              "-" +
              this.geoWerftData.objects.visible[i].homepage_status;
          }
          if (
            undefined === this.geoWerftData.objects.visible[i].map_pin ||
            "" === this.geoWerftData.objects.visible[i].map_pin
          ) {
            url = this.get_customizer_image_for_marker(
              this.geoWerftData.objects.visible[i].homepage_status,
              this.geoWerftData.objects.visible[i].display_badge_new
            );
          } else {
            url = this.geoWerftData.objects.visible[i].map_pin;
          }
          if (this.geoWerftData.objects.visible[i].vermarktungsart) {
            exclude_status =
              "," +
              this.geoWerftData.objects.visible[
                i
              ].vermarktungsart.toLowerCase() +
              ",";
          }
        }

        // Wenn die Funktion an ist und nicht leer, dann werden nur Pins geclustert die Übergeben werden.
        if (
          this.geoWerftData.checkboxes.select_cluster_active &&
          "" !== this.geoWerftData.texts.select_cluster_hp_to_show &&
          this.geoWerftData.texts.select_cluster_hp_to_show.indexOf(
            exclude_status,
            0
          ) === -1
        ) {
          this.geoWerftData.map.no_cluster_markers.push({
            // Add position
            position: {
              lat: parseFloat(
                this.geoWerftData.objects.visible[i].geo_latitude
              ),
              lng: parseFloat(
                this.geoWerftData.objects.visible[i].geo_longitude
              ),
            },
            permalink: this.geoWerftData.objects.visible[i].link,
            title: this.decodeHtmlEntity(title),
            url: url,
            label: "",
            animation: null,
            id: this.geoWerftData.objects.visible[i].id,
            index: i,
          });
        } else {
          this.geoWerftData.map.markers.push({
            // Add position
            position: {
              lat: parseFloat(
                this.geoWerftData.objects.visible[i].geo_latitude
              ),
              lng: parseFloat(
                this.geoWerftData.objects.visible[i].geo_longitude
              ),
            },
            permalink: this.geoWerftData.objects.visible[i].link,
            title: this.decodeHtmlEntity(title),
            url: url,
            label: "",
            animation: null,
            id: this.geoWerftData.objects.visible[i].id,
            index: 1,
          });
        }
      }
    },
    get_the_closest_marker() {
      var distance_table = [];
      var current_marker = "";
      for (let i = 0; i < this.coords_array.length; i++) {
        var current_distance = this.getDistance(
          this.current_center,
          this.coords_array[i].position
        );
        distance_table.push({
          distance: { current_distance },
          markerpos: this.coords_array[i].position,
        });
      }
      current_marker = this.get_smalest_number(distance_table);
      if (
        !isNaN(distance_table[current_marker].markerpos.lat) &&
        !isNaN(distance_table[current_marker].markerpos.lng) &&
        distance_table[current_marker].markerpos !== undefined
      ) {
        this.geoWerftData.map.center = distance_table[current_marker].markerpos;
      }
    },
    get_smalest_number(temp) {
      var index = 0;
      // Set Very high starting value to get the best result.
      var value = 99999999999999999999999;
      for (var i = 0; i < temp.length; i++) {
        if (
          !isNaN(temp[i].distance.current_distance) &&
          !isNaN(temp[i].markerpos.lat) &&
          !isNaN(temp[i].markerpos.lng)
        ) {
          if (temp[i].distance.current_distance < value) {
            value = temp[i].distance.current_distance;
            index = i;
          }
        }
      }
      return index;
    },
    getDistance(current_center, current_marker) {
      var rad = function (x) {
        return (x * Math.PI) / 180;
      };
      var earth_radius = 6378137; // Earth’s mean radius in meter
      var dLat = rad(current_marker.lat - current_center.lat());
      var dLong = rad(current_marker.lng - current_center.lng());
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(rad(current_center.lat())) *
          Math.cos(rad(current_marker.lat)) *
          Math.sin(dLong / 2) *
          Math.sin(dLong / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var distance = earth_radius * c;
      return distance; // returns the distance in meter
    },
    decodeHtmlEntity(str) {
      return str.replace(/&#(\d+);/g, function (match, dec) {
        return String.fromCharCode(dec);
      });
    },
    toggle_single_info_window_on_emit(current_id) {
      let fake_marker = [];
      for (let i = 0; i < this.geoWerftData.objects.visible.length; i++) {
        if (this.geoWerftData.objects.visible[i].id === current_id) {
          fake_marker = {
            position: {
              lat: parseFloat(
                this.geoWerftData.objects.visible[i].geo_latitude
              ),
              lng: parseFloat(
                this.geoWerftData.objects.visible[i].geo_longitude
              ),
            },
          };
          if (this.geoWerftData.checkboxes.enable_filialen_mode) {
            this.toggle_filialen_window(fake_marker, i);
          } else {
            this.toggleInfoWindow(fake_marker, i);
          }
          break;
        }
      }
    },
    get_placeholder_img_by_hp(homepage_status, img_url, prop_type) {
      if (
        homepage_status !== undefined &&
        prop_type !== undefined &&
        false === this.geoWerftData.interactive_filter_active
      ) {
        switch (homepage_status.toLowerCase()) {
          case "secret sale":
            img_url = this.geoWerftData.image_placeholder_secret;
            break;
          case "aktive marktbeobachtung":
            img_url = this.geoWerftData.image_placeholder_market_watch;
            if ("haus" === prop_type.toLowerCase()) {
              img_url = this.geoWerftData.image_placeholder_market_watch_house;
            }
            if ("wohnung" === prop_type.toLowerCase()) {
              img_url = this.geoWerftData.image_placeholder_market_watch_flat;
            }
            if ("grundstück" === prop_type.toLowerCase()) {
              img_url = this.geoWerftData.image_placeholder_market_watch_plot;
            }
            if ("" === img_url) {
              img_url = this.geoWerftData.image_placeholder_market_watch;
            }
            break;
          default:
            break;
        }
      }
      return img_url;
    },
    toggleInfoWindow(marker, idx) {
      this.markerInfo = true;
      localStorage.setItem("mw-last-visit-immoslider", window.location.href);
      this.win_id = this.inView[idx].id || "";
      this.win_display_badge_new = this.inView[idx].display_badge_new || "";
      this.geoWerftData.map.center = marker.position;
      this.infoWindowPos = marker.position;
      if (
        this.inView[idx].object_image_url === undefined ||
        this.inView[idx].object_image_url === ""
      ) {
        this.inView[idx].object_image_url = this.inView[idx].map_picture || "";
      }
      this.win_gesamtflaeche = this.mw_format_area(
        this.inView[idx].gesamtflaeche || ""
      );
      this.win_tour = this.inView[idx].ogulo_tour || "";

      this.image_url = this.inView[idx].object_image_url || "";
      this.win_objekttitel = this.inView[idx].objekttitel || "";
      if (undefined !== this.inView[idx].plz) {
        this.win_plz = this.inView[idx].plz;
      }
      this.win_ort = this.inView[idx].ort || "";
      this.win_geolocation = this.inView[idx].geolage || "";
      // Check if Objektart_geowerft is set.
      if ((this.inView[idx].objektart_geowerft || "") === "") {
        this.win_objektart_raw = this.inView[idx].objektart_raw || "";
      } else {
        this.win_objektart_raw = this.inView[idx].objektart_geowerft || "";
      }
      if (
        true === this.geoWerftData.geo_display_objecttype &&
        this.inView[idx].objekttyp
      ) {
        this.win_objektart_raw =
          this.inView[idx].objekttyp.charAt(0).toUpperCase() +
          this.inView[idx].objekttyp.slice(1);
      }
      this.win_vermarktungsart = this.inView[idx].vermarktungsart || "";
      this.win_kennung = this.inView[idx].kennung || "";
      this.win_count_adults = this.inView[idx].count_adults || 0;
      this.win_count_childs = this.inView[idx].count_childs || 0;
      this.win_barrierefrei = this.inView[idx].barrierefrei || 0;
      this.win_haustiere = this.inView[idx].haustiere || 0;
      this.win_price = this.inView[idx].kaufpreis || 0;
      this.win_price_rent = this.inView[idx].nettokaltmiete || 0;
      this.win_price_qm = this.inView[idx].mietpreis_pro_qm || 0;
      this.win_teilbarkeit = this.mw_format_area(this.inView[idx].teilbar_ab);
      this.win_bueroflaeche = this.mw_format_area(
        this.inView[idx].bueroflaeche
      );
      this.win_bezug = this.inView[idx].bezug || "";
      this.win_zimmer = this.inView[idx].anzahl_zimmer || 0;
      this.win_wohnflaeche = this.mw_format_area(this.inView[idx].wohnflaeche);
      this.win_vermietbare_flaeche = this.mw_format_area(
        this.inView[idx].vermietbare_flaeche
      );
      this.win_grundstuecksflaeche = this.mw_format_area(
        this.inView[idx].grundstuecksflaeche
      );
      this.win_homepage_status = this.inView[idx].homepage_status || "";
      this.win_link_extern_url = this.inView[idx].link_extern || "";
      if (
        ((this.inView[idx].homepage_status &&
          "aktive marktbeobachtung" ===
            this.inView[idx].homepage_status.toLowerCase()) ||
          (this.inView[idx].vermarktungsart &&
            "fremdobjekt" ===
              this.inView[idx].vermarktungsart.toLowerCase())) &&
        true === this.geoWerftData.checkboxes.logged_in_market_watch &&
        false === this.geoWerftData.user.logged_in
      ) {
        this.win_link_extern_url =
          this.geoWerftData.texts.market_watch_alt_link || "";
      }

      this.image_url = this.get_placeholder_img_by_hp(
        this.inView[idx].homepage_status,
        this.inView[idx].object_image_url,
        this.inView[idx].objektart_raw
      );

      this.win_link_extern = this.inView[idx].link_extern || "";
      this.win_link_extern = this.win_link_extern
        .replace("https://www.", "")
        .split("/")[0];
      this.win_erwerbsart = this.inView[idx].erwerbsart || "";
      this.win_res_begin = this.inView[idx].reservierung_begin || "";
      this.win_res_ende = this.inView[idx].reservierung_ende || "";
      this.permalink = this.inView[idx].link || "";
      //Check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //If different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
      if (
        true === this.geoWerftData.user.logged_in &&
        true === this.geoWerftData.geowerft_gtb_watchlist_active
      ) {
        document
          .querySelectorAll(".mw-gtb-watchlist-liked")
          .forEach(function (elm) {
            if (elm.classList.contains("mw-gtb-watchlist-liked")) {
              elm.classList.remove("mw-gtb-watchlist-liked");
            }
          });
        this.mw_change_watchlist_status_on_load(this.inView[idx].id || "");
      }
    },
    toggleClusterMarker(event) {
      this.geoWerftData.map.center = {
        lat: event.center_.lat() + 0.0001,
        lng: event.center_.lng(),
      };

      this.markerInfo = false;

      if (event.getMap().zoom < this.geoWerftData.map.maxZoom) {
        return;
      }

      const estates = [];
      var realEstates = event.getMarkers();
      for (var i in realEstates) {
        let estate = this.getEstateById(realEstates[i].title);

        if (estate) {
          if (
            estate.object_image_url === undefined ||
            estate.object_image_url === ""
          ) {
            estate.object_image_url = estate.map_picture || "";
          }
          estate.image_url = estate.object_image_url || "";
          estate.win_objekttitel = estate.objekttitel || "";
          if (undefined !== estate.plz) {
            estate.win_plz = estate.plz;
          }
          estate.win_ort = estate.ort || "";
          estate.win_geolocation = estate.geolage || "";
          if (estate.objektart_geowerft === "") {
            estate.win_objektart_raw = estate.objektart_raw || "";
          } else {
            estate.win_objektart_raw = estate.objektart_geowerft || "";
          }
          if (
            true === this.geoWerftData.geo_display_objecttype &&
            estate.objekttyp
          ) {
            this.win_objektart_raw =
              estate.objekttyp.charAt(0).toUpperCase() +
              estate.objekttyp.slice(1);
          }
          estate.win_vermarktungsart = estate.vermarktungsart || "";
          estate.win_kennung = estate.kennung || "";
          estate.win_count_adults = estate.count_adults || 0;
          estate.win_count_childs = estate.count_childs || 0;
          estate.win_homepage_status = estate.homepage_status || "";
          estate.win_count_adults = estate.count_adults || 0;
          estate.win_count_childs = estate.count_childs || 0;
          estate.win_price = estate.kaufpreis || 0;
          estate.win_price_rent = estate.nettokaltmiete || 0;
          estate.win_price_qm = estate.mietpreis_pro_qm || 0;
          estate.win_teilbarkeit = this.mw_format_area(estate.teilbar_ab);
          estate.win_bueroflaeche = this.mw_format_area(estate.bueroflaeche);
          estate.win_bezug = estate.bezug || "";
          estate.win_zimmer = estate.anzahl_zimmer || 0;
          estate.win_wohnflaeche = this.mw_format_area(estate.wohnflaeche);
          estate.win_vermietbare_flaeche = this.mw_format_area(
            estate.vermietbare_flaeche
          );
          estate.win_grundstuecksflaeche = this.mw_format_area(
            estate.grundstuecksflaeche
          );
          this.win_link_extern = estate.link_extern || "";
          estate.win_link_extern = this.win_link_extern
            .replace("https://www.", "")
            .split("/")[0];
          estate.win_link_extern_url = estate.link_extern || "";
          if (
            ((estate.homepage_status &&
              "aktive marktbeobachtung" ===
                estate.homepage_status.toLowerCase()) ||
              (estate.vermarktungsart &&
                "fremdobjekt" === estate.vermarktungsart.toLowerCase())) &&
            true === this.geoWerftData.checkboxes.logged_in_market_watch &&
            false === this.geoWerftData.user.logged_in
          ) {
            estate.win_link_extern_url =
              this.geoWerftData.texts.market_watch_alt_link || "";
          }
          estate.permalink = estate.link || "";
          estate.win_erwerbsart = estate.erwerbsart || "";
          estate.win_haustiere = estate.haustiere || 0;
          estate.win_barrierefrei = estate.barrierefrei || 0;
          estate.win_id = estate.id || "";
          estates.push(estate);
        }
      }
      var marker = realEstates[0];
      let idx = 0;
      this.estates = estates;
      this.geoWerftData.map.center = marker.position;
      this.infoWindowPos = marker.position;
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    getEstateById(title) {
      for (let i in this.inView) {
        let kennung = this.inView[i].kennung || "";
        if ("" !== kennung && true === title.includes(kennung)) {
          return this.inView[i];
        }
      }
    },
    toggle_filialen_window(marker, idx) {
      this.geoWerftData.map.center = marker.position;
      this.infoWindowPos = marker.position;

      this.win_filialen_id = this.inView[idx].id;
      this.win_img_src = this.inView[idx].object_image_url;
      this.win_name = this.inView[idx].objekt_titel;
      this.win_headline = this.inView[idx].info_head;
      this.win_headline_ort = this.inView[idx].info_ort;
      this.win_strasse = this.inView[idx].strasse;
      this.win_plz = this.inView[idx].plz;
      this.win_tel = this.inView[idx].telefon;
      this.win_tel_zwei = this.inView[idx].telefon_zwei;
      this.win_mail = this.inView[idx].email;
      this.win_fax = this.inView[idx].fax;
      this.win_link_extern_url = this.inView[idx].link;
      //Check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //If different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
  },
};
</script>

<style>
.info-window-content {
  overflow: hidden;
  width: 100%;
  max-width: 20ch;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/objectMap.vue